import { Transition, TransitionChild } from "@headlessui/react";

import LoadingAnimation from "./LoadingAnimation";

export function Loading({ isLoading }: { isLoading: boolean }) {
  return (
    <Transition show={isLoading}>
      <TransitionChild
        enter="transition ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 left-0 z-[9999] bg-gray-850/80">
          <LoadingAnimation />
        </div>
      </TransitionChild>
    </Transition>
  );
}
